import { api } from "@/lib/api";
import {
  CreateRegion,
  createRegionToDto,
  Region,
  RegionDtoSchema,
  regionFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getRegionsQueryOptions } from "./get.hooks";

export function useCreateRegion(opts?: {
  onSuccess?: (region: Region) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (region: CreateRegion) => {
      const dto = createRegionToDto(region);
      const result = await api.post("/api/regions", dto, RegionDtoSchema);
      return regionFromDto(result);
    },
    onSuccess: (region) => {
      queryClient.setQueryData(getRegionsQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        region,
      ]);
      toast({
        title: "toast.regionCreated",
        variant: "success",
      });
      opts?.onSuccess?.(region);
    },
    onError: () => {
      toast({
        title: "toast.createRegionError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
